module.exports = __webpack_public_path__ + "img/lisa_h.ce306d24.png";